import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { CanActivateChildGuard } from './auth/guards/can-activate-child.guard';
import { LoginGuard } from './auth/guards/login.guard';
import { AdminGuard } from './auth/guards/admin.guard';

const routes: Routes = [
  // Login
  {
    path: '',
    canActivate: [LoginGuard],
    loadChildren: () => import('./auth/auth.module').then((m) => m.AuthModule),
  },
  // Dashboard
  {
    path: 'dashboard',
    canActivate: [CanActivateChildGuard],
    loadChildren: () =>
      import('./dashboard/dashboard.module').then((m) => m.DashboardModule),
  },

  // Admin
  {
    path: 'admin',
    canActivate: [CanActivateChildGuard, AdminGuard],
    loadChildren: () =>
      import('./admin/admin.module').then((m) => m.AdminModule),
  },

  {
    path: 'client',
    // canActivate: [CanActivateChildGuard],
    loadChildren: () =>
      import('./client/client.module').then((m) => m.ClientModule),
  },
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule],
})
export class AppRoutingModule { }
